// extracted by mini-css-extract-plugin
export default {"homeContainer":"Home_homeContainer__GxC9g","childContainer":"Home_childContainer__aSktS"};